<script lang="ts" setup>
import { cva } from 'class-variance-authority'

import { classMerge } from '../utils'

const textVariants = cva(
  'text-foreground',
  {
    variants: {
      variant: {
        headline: 'font-heading text-heading-md',
        regular: 'font-ui text-ui-md',
        link: 'font-ui text-ui-md underline'
      }
    },
    defaultVariants: {
      variant: 'regular'
    }
  }
)

withDefaults(defineProps<{
  variant?: 'headline' | 'regular' | 'link'
  className?: string,
  href?: string
}>(), {
  variant: 'regular',
  className: '',
  href: ''
})
</script>

<template>
  <a v-if="variant == 'link'"
     :href="href"
     :class="classMerge(textVariants({ variant: variant }), className)">
    <p :class="classMerge(textVariants({ variant: variant }), className)">
      <slot />
    </p>
  </a>
  <p v-else
     :class="classMerge(textVariants({ variant: variant }), className)">
    <slot />
  </p>
</template>
